import { Component } from '@angular/core';

import { SseNotificationService } from './sse-notification.service';
import { pcgSettings } from '../generated/pcg-settings';
import { GlobalVariablesService } from '../../services/global-variables.service';
import { Router } from '@angular/router';
import { UserJsVm } from '../generated/Admin/Models/User/UserJsVm';
import { SecurityService } from '../../core/security/security.service';

@Component({
    selector: 'pcg-sse-notification',
    standalone: false,
    templateUrl: './sse-notification.component.html',
    styleUrl: './sse-notification.component.scss'
})
export class SseNotificationComponent {
    
	isLocalHost = pcgSettings.mode === 'Development';

    private eventSource: EventSource;

    user: UserJsVm;

    constructor(public gvs: GlobalVariablesService, public router: Router, public sec: SecurityService) {}

	/** Reload the page */
	hardReload() {
		window.location.href = window.location.origin + window.location.pathname + '?cacheBust=' + new Date().getTime();
		return false;
	}

    changeContact() { 
        this.user = this.sec.getUser();
        this.router.navigateByUrl(`admin/settings/contacts/${this.user.clientId}`); 
    }

	ngOnInit() { if (!this.isLocalHost) { this.connectToSSE(); } }
	ngOnDestroy() { if (this.eventSource) { this.eventSource.close(); } }

	/** Connect to Server Sent Event and listen for events */
	private connectToSSE() {
        // This ensures cookies are sent with the request
        this.eventSource = new EventSource(
            `/api/install-events`
            , { withCredentials: true }
        );

		this.eventSource.addEventListener(
            'install'
            , () => {
                this.gvs.showInstallNotification.set(true);
                localStorage.removeItem('update-timer');
                SseNotificationService.checkForSystemUpdate();
                this.gvs.showScheduledInstallNotification.set(false);
            }
        );

		this.eventSource.addEventListener(
            'install-scheduled'
            , (event: MessageEvent) => {
                const scheduledTime = new Date(JSON.parse(event.data));
                localStorage.setItem('update-timer', JSON.stringify(scheduledTime));
                this.gvs.showScheduledInstallNotification.set(SseNotificationService.checkForSystemUpdate() != null);
            }
        );
	}
}
